<template>
	<ObjectList :options="options" />
</template>
<script>
export default {
	name: 'ListSelection',
	props: ['options']
};
</script>
